import { useRecoilValue } from 'recoil';

import { basketCustomerOrderResumeState } from '../../../store/batchTicket/atom';

export const useBatchTicketRequiredAttention = () => {
  const requiredAttentionData = useRecoilValue(basketCustomerOrderResumeState).data.errors;

  return {
    requiredAttentionData,
  };
};
